import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

// Actions & Services
import { loadInvoice, confirmPayment } from '../../reducers/invoices';

// Components
import CustomModal from 'components/CustomModal';
import InputCertificateNumber from '../InputCertificateNumber/index';
import PaymentSelection from './PaymentSelection';

// Styles
import * as modalStyles from 'components/CustomModal/styles';

function getCertificateNumber(invoice) {
  if (invoice) {
    return (
      (invoice.certificateNumber && Number(invoice.certificateNumber)) ||
      (invoice.maxCertificateNumber && Number(invoice.maxCertificateNumber)) ||
      ''
    );
  }
  return '';
}

function getAppointmentId(appointment) {
  if (
    typeof appointment.activeAppointment === 'object' &&
    Object.keys(appointment.activeAppointment).length
  ) {
    return appointment.activeAppointment.id;
  }
}

class PaymentModal extends Component {
  constructor(props) {
    super(props);
    const {
      appointment: { invoice }
    } = props;

    this.state = {
      paymentMethod: null,
      certificateNumber: getCertificateNumber(invoice),
      certificateError: null,
      invoiceChanged: null
    };
    this.closeModal = this.closeModal.bind(this);
    this.onClickConfirmPayment = this.onClickConfirmPayment.bind(this);
    this.onChangeCertificateNumber = this.onChangeCertificateNumber.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpen, appointment, loadInvoice } = this.props;
    // init load invoice if don't have it
    const invoice = appointment.invoice;
    if (!prevProps.isOpen && isOpen) {
      if (invoice && !Object.keys(invoice).length) {
        loadInvoice(getAppointmentId(appointment));
      }
    }
    // update state after loading new invoice
    if (JSON.stringify(invoice) !== JSON.stringify(prevProps.appointment.invoice)) {
      this.setState({ certificateNumber: getCertificateNumber(invoice) });
    }
  }

  addPaymentMethod(paymentMethod) {
    this.setState({ paymentMethod });
  }

  closeModal() {
    this.setState({
      paymentMethod: null,
      certificateNumber: '',
      certificateError: null,
      invoiceChanged: null
    });
    this.props.closeModal();
  }

  onClickConfirmPayment() {
    const { paymentMethod, certificateNumber } = this.state;
    const { appointment } = this.props;
    const invoice = appointment.invoice;
    if (confirmPayment && paymentMethod) {
      confirmPayment(invoice, getAppointmentId(appointment), {
        paymentMethod,
        certificateNumber
      }).then(
        () => {
          this.closeModal();
        },
        err => {
          this.setState({ [err.type]: err.label });
        }
      );
    }
  }

  onChangeCertificateNumber(value) {
    this.setState({ certificateNumber: value, certificateError: null });
  }

  render() {
    const {
      isOpen,
      i18n,
      appointment: { invoice }
    } = this.props;
    const { paymentMethod, certificateError, invoiceChanged } = this.state;

    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={this.closeModal}
        style={{ content: { maxWidth: '35em', padding: 0 } }}
      >
        <modalStyles.CommonModalWrapper>
          {/* ──── Header ────────────────────────────────────────────────────────────────────── */}
          <modalStyles.ModalBlockSection className="header-wrapper">
            <modalStyles.ModalCloseIcon className="close-icon" onClick={this.closeModal} />
            <modalStyles.ModalTitle>{i18n.t('confirm_pay_popup_title')}</modalStyles.ModalTitle>
          </modalStyles.ModalBlockSection>

          {/* ──── Content ──────────────────────────────────────────────────────────────────── */}
          {/* Payment blocks */}
          <modalStyles.ModalBlockSection bottomBorder>
            <modalStyles.ModalText style={{ marginBottom: '1.1em' }}>
              {i18n.t('select_payment_method_popup')}
            </modalStyles.ModalText>

            <PaymentSelection
              paymentMethod={paymentMethod}
              errorLabel={invoiceChanged}
              onClick={e => this.addPaymentMethod(e)}
            />

            {invoiceChanged && <span className="error-message">{i18n.t(invoiceChanged)}</span>}
          </modalStyles.ModalBlockSection>

          {/* Certificate */}
          <modalStyles.ModalBlockSection borderTop style={{ marginBottom: '.3em' }}>
            <modalStyles.ModalText style={{ marginBottom: '1.1em' }}>
              {i18n.t('next_certificate_number')}
            </modalStyles.ModalText>
            <InputCertificateNumber
              error={certificateError}
              maxCertificateNumber={getCertificateNumber(invoice)}
              onChangeCertificate={this.onChangeCertificateNumber}
            />
            {certificateError && <span className="error-message">{i18n.t(certificateError)}</span>}
          </modalStyles.ModalBlockSection>

          {/* ──── Footer ───────────────────────────────────────────────────────────────────── */}

          <modalStyles.ModalFooter className="footer" topBorder>
            <modalStyles.ModalCancel onClick={this.closeModal}>
              {i18n.t('popup_cancel_button')}
            </modalStyles.ModalCancel>

            <modalStyles.ModalFooterBtn
              style={{ minWidth: '140px' }}
              disabled={!paymentMethod || invoiceChanged || certificateError}
              onClick={this.onClickConfirmPayment}
            >
              {i18n.t('popup_confirm_button')}
            </modalStyles.ModalFooterBtn>
          </modalStyles.ModalFooter>
        </modalStyles.CommonModalWrapper>
      </CustomModal>
    );
  }
}

const mapStateToProps = state => ({
  appointment: state.practitioner.appointment
});

export default translate()(
  connect(
    mapStateToProps,
    {
      loadInvoice
    }
  )(PaymentModal)
);
